import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import UsageExpiredAlert from './UsageExpiredAlert';

type SubscriptionRequiredModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSubscribed?: () => void;
};

/**
 * Pop-up affichée quand un compte non payant tente de lancer un live.
 * Le back renvoie un 402 `SUBSCRIPTION_REQUIRED.LIVE_START` ; côté front on bloque l'action
 * en amont et le CTA ouvre directement le parcours d'abonnement (sélection de forfait + paiement).
 */
export default function SubscriptionRequiredModal({
  open,
  onOpenChange,
  onSubscribed,
}: SubscriptionRequiredModalProps) {
  const { t } = useTranslation('billing');

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>{t('subscriptionRequired.title')}</DialogTitle>
          <DialogDescription>{t('subscriptionRequired.description')}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          {/* Le bouton « Choisir un plan » d'UsageExpiredAlert ouvre la pop-up d'abonnement. */}
          <UsageExpiredAlert isConfig triggerClassName="w-full" onSubscribed={onSubscribed} />
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
